import {API_FEEDBACK_REVIEW_FORMULATRIX, API_FEEDBACK_REVIEW_LEAD} from '../../const/Api';
import {callAPI} from './callApi';
import {RestApiMethod} from '../../const/dataEnum';

export const getFeedbackReviewFormulatrix = async (periodId) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_FEEDBACK_REVIEW_FORMULATRIX}/${periodId}`,
    });
    return res.data;
  } catch (error) {
    console.error('getFeedbackReviewFormulatrix Error:', error.message);
    return null;
  }
};

export const getFeedbackReviewLead = async (periodId, pageNo, pageSize) => {
  try {
    const params = {
      pageNo,
      pageSize,
    };

    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_FEEDBACK_REVIEW_LEAD}/${periodId}`,
      params: params,
    });
    return res.data;
  } catch (error) {
    console.error('getFeedbackReviewLead Error:', error.message);
    return null;
  }
};
